import React, { useEffect, useState } from "react";

import useRooms from "./hooks/useRooms";

import AdminPageHeader from "../widgets/PageHeader";
import AdminRoomTable from "./widgets/RoomTable";
import RoomCreateModal from "./widgets/RoomCreateModal";
import { Button } from "antd";
import { TransitionedRoutePage } from "../admin.style";
import LoadingIndicator from "common/components/LoadingIndicator";

function RoomAdmin() {
	const { rooms, error, status, fetchRooms } = useRooms();
	const [showCreateModal, setShowCreateModal] = useState<boolean>(false);

	useEffect(() => {
		if (!rooms.length) fetchRooms();

		// eslint-disable-next-line
	}, []);

	return (
		<TransitionedRoutePage>
			<AdminPageHeader
				page="Rooms"
				indicator={<LoadingIndicator loading={[status]} />}
			>
				<Button onClick={() => setShowCreateModal(!!!showCreateModal)}>
					Add New
				</Button>
			</AdminPageHeader>
			{error && <p className="error">{error}</p>}
			<AdminRoomTable isLoading={status === "loading"} rooms={rooms} />
			<RoomCreateModal
				visible={!!showCreateModal}
				closeModal={() => setShowCreateModal(false)}
			/>
		</TransitionedRoutePage>
	);
}

export default RoomAdmin;
